/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { FlexRow, Inline, Placeholder } from 'sarsaparilla';
import FindACampsiteSectionListPlaceholder from './FindACampsiteSectionListPlaceholder';
import '../FindACampsiteSection.scss';
import './FindACampsiteSectionPlaceholder.scss';

export default function FindACampsiteSectionPlaceholder() {
    return (
        <div
            id="find-a-campsite-section"
            className="campground-page-v3-section find-a-campsite-section-placeholder"
            aria-hidden="true"
        >
            <FlexRow justifyContent="space-between" alignItems="end">
                <Placeholder
                    className="campground-page-v3-heading"
                    height="32px"
                    width="200px"
                />
                <Placeholder height="36px" width="96px" />
            </FlexRow>
            <div className="find-a-campsite-section-placeholder-date">
                <Placeholder height="48px" width="100%" />
            </div>
            <Inline space="xs" className="find-a-campsite-filters" noWrap>
                <Placeholder height="40px" width="80px" />
                <Placeholder height="40px" width="100%" />
            </Inline>
            <FindACampsiteSectionListPlaceholder />
            <div className="find-a-campsite-section-placeholder-map">
                <Placeholder height="44px" width="100px" />
            </div>
        </div>
    );
}
